import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Navbar from '../../../components/Navbar'
import Breadcumb from '../../../components/breadcumb'

import FooterSection from '../../../components/Footer'

import pr_1 from '../../../images/logo/web_655_logo_n-logo.png';
import pr_2 from '../../../images/logo/web_655_logo_n-logo.png';
import pr_3 from '../../../images/logo/web_655_logo_n-logo.png';
import i18next from 'i18next';
import i18n from './../../../i18n';

class SolutionsSection extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        var settings = {
            dots: true,
            arrows: true,
            speed: 1200,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            autoplaySpeed:5500,
            fade:true
        };
        return (
            <div>
           <Navbar/>
           <Breadcumb bdtitle={i18n.t('practice-label')} bdsub={i18n.t('practice-detail-label')}/>
            <div className="practice-details-area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 col-12 p-p">
                            <div className="row">
                                <div className="col-lg-12 col-md-6 col-12">
                                    <div className="field-section">
                                        {/* <div className="field-img"> */}
                                        <div>
                                            <img src={pr_1} alt=""/>
                                        </div>
                                        {/* <div className="field-content">
                                            <h3><span>25</span>Years of Experience In This Field</h3>
                                            <div className="btns">
                                                <div className="btn-style"><Link to="/contact">Contact Us Now</Link></div>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-6 col-12">
                                    <div className="practice-catagory-item">
                                        <div className="widget-title">
                                            <h3 className="text-left">{i18n.t('practice-title-description-label')}</h3>
                                        </div>
                                        <div className="practice-section">
                                            <ul>
                                            <li><Link to="/telecom">{i18n.t('practice-telecom-pole-label')}</Link></li>
                                                <li><Link to="/computer-science">{i18n.t('practice-computer-science-label')}</Link></li>
                                                <li><Link to="/software">{i18n.t('practice-software-label')}</Link></li>
                                                <li><Link to="/training">{i18n.t('practice-certification-label')}</Link></li>
                                                <li><Link to="/solutions" style={{color: "#15729f"}}>{i18n.t('practice-solution-label')}</Link></li>
                                                <li><Link to="/support">{i18n.t('practice-support-label')}</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-12">
                            {/* <div className="practice-section-img">
                                <img src={pr_2} alt=""/>
                            </div> */}
                            <div className="practice-section-text">
                                <h2>{i18n.t('practice-solution-label')}</h2>
                                {/* <h5>I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born </h5> */}
                                <p className="justify-text">{i18n.t('solution-part-one-label')}</p>
                            </div>
                            {/* <div className="organigation-area"> */}
                                {/* <div className="organaigation-img">
                                    <img src={pr_3} alt=""/>
                                </div> */}
                                <div className="organigation-text">
                                    {/* <h2>Family Law Organizations</h2> */}
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-two-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-three-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-four-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-five-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-six-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-seven-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-height-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-nine-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-ten-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-eleven-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-twelve-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-thirteen-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-fourteen-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-fifteen-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-sixteen-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-seventeen-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-heighteen-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-nineteen-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-twenty-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-twentyone-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-twentytwo-label')}</span>
                                    <span><i className="fa fa-check-square-o" aria-hidden="true"></i>{i18n.t('solution-list-twentythree-label')}</span>

                                </div>
                            {/* </div> */}
                            <div className="practice-section-text">
                                <p> <Link to="/#contact-section">{i18n.t('contact-us-link-label')}</Link>, {i18n.t('contact-special-label')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterSection/>
       </div>
        );
    }
}

export default SolutionsSection;